module.exports = __webpack_public_path__ + "static/media/AdminLogo.f20ad477.png";